export default class LoadingIndicatorExtension {
    constructor(defaultLoadingIndicatorSelector) {
        this.defaultLoadingIndicatorSelector = defaultLoadingIndicatorSelector;
    }

    initialize(naja) {
        this.defaultLoadingIndicator = document.querySelector(this.defaultLoadingIndicatorSelector);
        naja.uiHandler.addEventListener('interaction', this.locateLoadingIndicator.bind(this));
        naja.addEventListener('start', this.showLoader.bind(this));
        naja.addEventListener('complete', this.hideLoader.bind(this));
    }

    locateLoadingIndicator({detail}) {
        const loadingIndicator = detail.element.closest('[data-loading-indicator]');
        detail.options.loadingIndicator = loadingIndicator || this.defaultLoadingIndicator;
    }

    showLoader({detail}) {
        const loader = (detail.options.loadingIndicator) ? detail.options.loadingIndicator : this.defaultLoadingIndicator;
        loader.classList.add('loader--active');
    }

    hideLoader({detail}) {
        const loader = (detail.options.loadingIndicator) ? detail.options.loadingIndicator : this.defaultLoadingIndicator;
        loader.classList.remove('loader--active');
    }
}